import { queryOptions } from "@tanstack/react-query";
import type { AgUiTool } from "@strands/agent-transport";
import { apiFetch } from "@/shared/api";

/**
 * AG-UI «interactive» tools catalog. Source-of-truth lives on the backend
 * (`backend/frontend_tools.py`) so headless callers (webhook fires, cron
 * routines) and the chat client see the exact same toolspec — without
 * sharing, the LLM behaviour drifts between sessions started from chat
 * vs. from a webhook.
 *
 * `staleTime: Infinity` — the catalog is part of the deploy, not session
 * state. ChatPage registers everything in this list via
 * `ChatActions.registerTool` once it resolves.
 */
export const frontendToolsQueryOptions = () =>
  queryOptions({
    queryKey: ["frontend-tools"],
    queryFn: async (): Promise<AgUiTool[]> => {
      const resp = await apiFetch("/api/frontend-tools");
      if (!resp.ok) throw new Error(await resp.text());
      const data: { tools?: AgUiTool[] } = await resp.json();
      return data.tools ?? [];
    },
    staleTime: Infinity,
  });
